import TcVod from 'vod-js-sdk-v6'
import axios from 'axios';
import store from '../store/store';
let fileAction = `${process.env.BASE_URL}/fodder/getSignature`;

var tcVod;

async function uploadTC(mediaFile) {
    function getSignature() {
        return axios.post(fileAction).then(function (response) {
            return response.data;
        })
    };
    tcVod = new TcVod({
        getSignature: getSignature // 前文中所述的获取上传签名的函数
    });
        let uploader = tcVod.upload({
            mediaFile: mediaFile.file, // 媒体文件（视频或音频或图片），类型为 File
        });

        uploader.on('media_progress', function (info) {
            let data = {
                percent: info.percent,
                index: mediaFile.file.uid
            };
            store.commit("getUploadData", data);
            console.log("进度", info.percent); // 进度
            // return info.percent;
        });
        uploader.done().then(function (doneResult) {
            console.log("结束", doneResult);
            let data = {
                fileId: doneResult.fileId,
                uid: mediaFile.file.uid
            };
            store.commit("getFileIdData",data);
            return doneResult;
        }).catch(function (err) {
        });
}
export { uploadTC }


// WEBPACK FOOTER //
// ./src/upload/tecent.js